import { Col, Menu, Row, Space } from "antd";
import Search from "antd/es/transfer/search";
import { useEffect, useState } from "react";

import esriRequest from "@arcgis/core/request";

import Graphic from '@arcgis/core/Graphic';
import SimpleLineSymbol from '@arcgis/core/symbols/SimpleLineSymbol';
import SimpleFillSymbol from '@arcgis/core/symbols/SimpleFillSymbol';
import SimpleMarkerSymbol from '@arcgis/core/symbols/SimpleMarkerSymbol';
import * as geometryJsonUtils from "@arcgis/core/geometry/support/jsonUtils.js";
import { getProxiedUrl } from "../../utilities/MapUtilities";

const SearchComponent = ({ mapView, placeholder, queries }) => {
    //queryUrl, searchfields, resultsfields
    mapView = mapView ? mapView : window.mapView; //SI no lo recibimos, la recuperamos del navegador

    const [text, setText] = useState("");
    const [results, setResults] = useState([]);

    useEffect(() => {
    }, [])

    const onChange = (e) => {
        setText(e.target.value);
        if (e.target.value && e.target.value.length > 2) {
            request(e.target.value)
        }
        else {
            setResults([]);
        }

    };

    const getWhere = (query, value) => {
        let clauses = []
        for (let i in query.searchfields) {
            let field = query.searchfields[i];

            clauses.push(`(UPPER(${field}) LIKE '%${value.toUpperCase()}%')`);
        }
        console.log('cluses', clauses)
        return clauses.join(' OR ');
    }

    const getLabel = (query, feature) => {
        let values = [];
        for (var i in query.resultsfields) {
            let key = query.resultsfields[i];
            if (key in feature.attributes) {
                values.push(feature.attributes[key]);
            }
        }
        let v = values.join(', ');
        return query.mask.replace("${value}", v);
    }

    function getItem(label, key, icon, children, type) {
        return {
            key,
            icon,
            children,
            label,
            type,
        };
    }

    const getMenuItems = () => {
        let out = [];
        for (let i in results) {
            out.push(getItem(results[i].label, i))
        }
        return out;

    }

    const onMenuClick = (e) => {
        console.log("CLICK", e)
        console.log("mapView", mapView)

        let esriGeom = geometryJsonUtils.fromJSON(results[e.key].geometry);
        zoom(esriGeom);

        setText("");
        setResults([]);
    }

    const addGeometry = (geometry) => {
        let symbol;

        if (geometry.declaredClass.toUpperCase().includes("POLYLINE")) {
            symbol = new SimpleLineSymbol({
                color: [51, 255, 233, 0.3],
                width: "15px",
                style: "solid"
            });
        }
        else if (geometry.declaredClass.toUpperCase().includes("POLYGON")) {
            symbol = new SimpleFillSymbol({
                color: [51, 255, 233, 0.3],
                outline: {
                    color: [255, 255, 255],
                    width: 3,
                },
            });
        }
        else if (geometry.declaredClass.toUpperCase().includes("POINT")) {
            symbol = new SimpleMarkerSymbol({
                style: "circle",
                size: "50px",
                color: [51, 255, 233, 0.3],
                outline: {
                    color: [255, 255, 255],
                    width: 3,
                },
            });
        }
        else {
            alert("TODO geometría no contemplada");
        }

        mapView.graphics.removeAll();
        const graphic = new Graphic({
            geometry: geometry,
            symbol: symbol,
        });
        mapView.graphics.add(graphic);
    }

    const zoom = (geometry) => {
        if (geometry.declaredClass.toUpperCase().includes("POINT")) {
            mapView.scale = 5000;
            mapView.goTo({
                target: geometry,
                zoom: 15
            })
        }
        else {
            mapView.goTo(geometry.extent.expand(1.5));
        }

        addGeometry(geometry);
    }

    const request = async (value) => {
        let values = [];

        for (let queriesIndex in queries) {
            let query = queries[queriesIndex];

            if (!query.searchfields || !query.resultsfields || query.searchfields.length === 0 || query.resultsfields.length === 0) {
                console.error("Invalid query configuration", query);
                continue;
            }

            let options = {
                responseType: "json",
                query: {
                    f: "pjson",
                    returnGeometry: true,
                    //outSR: mapView.spatialReference.wkid,
                    outSR: 4326,
                    where: getWhere(query, value),
                    outFields: query.resultsfields.join(','),
                    orderByFields: query.resultsfields.join(',')
                }
            }
      
            let response = null;
            try{
                // Usar URL con proxy en desarrollo
                const proxiedQueryUrl = getProxiedUrl(query.queryUrl);
                console.log(`[SearchComponent] Usando URL para query: ${proxiedQueryUrl}`);
                response = await esriRequest(proxiedQueryUrl, options);
            }
            catch(e){
                console.error("Error fetching data", e);
                continue;
            }
            

            for (let i in response.data.features) {
                let feature = response.data.features[i];
                values.push({
                    label: getLabel(query, feature),
                    geometry: feature.geometry
                });
            }
            

            /*
            esriRequest(query.queryUrl, options).then(function (response) {           
                let values = [];
                for (let i in response.data.features) {
                    let feature = response.data.features[i];
                    values.push({
                        label: getLabel(feature),
                        geometry: feature.geometry
                    });
                }
                setResults(values);
            });*/
        }

        setResults(values);


    }

    return (
        <>
            <Row>
                <Col span={24}>
                    <Search
                        value={text}
                        placeholder={placeholder}
                        onChange={onChange}
                        style={{
                            width: 200,
                        }}>
                        {
                            results.map(function (result) {
                                return <>{result.label}</>
                            })}
                    </Search>
                </Col>
            </Row>

            <Row>
                {results && results.length > 0 &&
                    <Col span={24}>
                        <Menu
                            mode="vertical"
                            onClick={onMenuClick}
                            style={{                       
                                position: "absolute"
                            }}
                            items={getMenuItems()}
                        />
                    </Col>
                }
            </Row>
        </>
    )
};
export default SearchComponent;